import { Typography, Flex, Alert, Button } from 'front-commons/ds';
import { Draggable, DroppableProvided } from 'react-beautiful-dnd';
import DistributorCard from 'containers/Cards/DistributorCard';
import ColumnsCTA from './CTA';
import DummyCards from './DummyCards';
import { DistributorsSelectedProps } from './interfaces';
import { SelectedCardsWrapper } from './styles';
import useCustomer from 'stores/customer';

export default function SelectedColumn({
	buId,
	isPed,
	posList,
	isTablet,
	isDrawer,
	CustomCTA,
	pharmacyId,
	hideMinValue,
	dropProvided,
	hasPermission,
	filterComponent,
	callToActionProps,
	originalVersionDate,
	selectedDistributors,
	onRemove,
	onReorder,
	onMirrorPOSConfig,
}: DistributorsSelectedProps & { dropProvided: DroppableProvided }) {
	const {
		customerStore: {
			data: { hyperaRole },
		},
	} = useCustomer();

	const canShowMirrorCTA = {
		posAmount: typeof posList === 'string' || posList?.length === 1,
		hyperaRole,
		hasNotSelected: !selectedDistributors?.distributors?.length,
		hasNotOriginalDate: !originalVersionDate,
	};

	return (
		<Flex direction="column" gap="24px" minWidth={{ medium: 'calc(50% - 32px)' }} order={{ small: 1, medium: 2 }}>
			<Flex justifyContent="center" textAlign="center" display={{ small: 'none', medium: 'flex' }}>
				<Typography variant="Label/M">Distribuidores selecionados</Typography>
			</Flex>

			{Object.values(canShowMirrorCTA).every(Boolean) && (
				<Alert type="info" toastMode>
					<Flex
						gap="16px"
						direction={{ small: 'column', large: isDrawer ? 'column' : 'row' }}
						alignItems={{ large: isDrawer ? undefined : 'center' }}
					>
						<Typography>Use a configuração do cliente como base para preencher sua lista de distribuidores.</Typography>
						<Button variant="outlined" size="small" onClick={onMirrorPOSConfig}>
							Importar distribuidores
						</Button>
					</Flex>
				</Alert>
			)}

			{!isTablet && filterComponent}

			<Flex
				direction="column"
				data-testid="selected-distributors"
				gap={{ small: '16px', medium: '8px' }}
				ref={dropProvided.innerRef}
				{...dropProvided.droppableProps}
				style={{ position: 'relative' }}
			>
				<SelectedCardsWrapper isPed={isPed}>
					{selectedDistributors?.distributors?.map((props, index) => (
						<Draggable key={props.id} draggableId={props.id} index={index}>
							{(dragProvided, dragSnapshot) => {
								console.log(props.summarizedCorporateName, { dragProvided, dragSnapshot, dropProvided });

								return (
									<DistributorCard
										isPed={isPed}
										active={{
											...props,
											index,
											order: index,
											isTablet,
											pharmacyId,
											dragSnapshot,
											dragProvided,
											hideMinValue,
											hasPermission,
											selectedLength: selectedDistributors.distributors?.length,
											onRemove,
											onReorder,
										}}
									/>
								);
							}}
						</Draggable>
					))}
				</SelectedCardsWrapper>
				<Flex
					width="100%"
					direction="column"
					gap="8px"
					display={{ small: 'none', medium: 'flex' }}
					style={{ position: 'absolute', zIndex: 0 }}
				>
					<DummyCards
						type="PLACEHOLDER"
						selectedLength={selectedDistributors?.distributors?.length}
						length={isPed ? 1 : 5}
						hasPermission={hasPermission}
						isTablet={isTablet}
					/>
				</Flex>
				{!CustomCTA && (
					<Flex display={{ small: 'none', medium: 'flex' }}>
						<ColumnsCTA
							{...callToActionProps}
							selectedDistributors={selectedDistributors}
							posList={posList}
							buId={buId}
						/>
					</Flex>
				)}
			</Flex>
		</Flex>
	);
}
